module.exports = __webpack_public_path__ + "img/SoftwareCopyright_12.988a2460.png";